import { Link } from "react-router-dom";
import { categories } from "../../mocks/categories";

const siteLinks = [
  { to: "/", label: "首页" },
  { to: "/works", label: "作品库" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="border-t border-primary-500/20 bg-background-500">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                忍界同人志
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-400">
              聚合火影忍者同人作品、合集与社区导航的垂直内容站，按目录整理热门推荐，帮助你一站式追更同人，追更不迷路。
            </p>
            <div className="mt-5 flex items-center gap-3 text-foreground-300">
              <a href="mailto:hello@nijitongren.example.com" aria-label="邮箱" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300/70 transition-colors hover:border-primary-500/60 hover:text-primary-300">
                <i className="ri-mail-line" />
              </a>
              <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300/70 transition-colors hover:border-primary-500/60 hover:text-primary-300">
                <i className="ri-weibo-line" />
              </a>
              <a href="#" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300/70 transition-colors hover:border-primary-500/60 hover:text-primary-300">
                <i className="ri-bilibili-line" />
              </a>
              <a href="#" aria-label="GitHub" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300/70 transition-colors hover:border-primary-500/60 hover:text-primary-300">
                <i className="ri-github-line" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wider text-foreground-950">
              快速导航
            </h3>
            <ul className="mt-4 space-y-2.5">
              {siteLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground-400 transition-colors hover:text-primary-300">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wider text-foreground-950">
              同人分类
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.id}>
                  <Link to={`/works?cat=${c.id}`} className="text-sm text-foreground-400 transition-colors hover:text-primary-300">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wider text-foreground-950">
              关于站点
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm leading-relaxed text-foreground-400">
              <li>本站为同人爱好者自建内容导航站</li>
              <li>所有作品版权归原作者与版权方所有</li>
              <li>内容坚持原创收录、尊重原著的收录原则</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-400">
            © 2026 忍界同人志 · 火影忍者同人作品合集与导航目录
          </p>
          <p className="text-xs text-foreground-400">
            同人作品与社区资源持续更新 · 追更不迷路
          </p>
        </div>
      </div>
    </footer>
  );
}